export default __webpack_public_path__ + "static/media/_DSC0362.0e99544c.JPG";